// removed by extract-text-webpack-plugin
module.exports = {"element":"element__element___368eg","drop-preview":"element__drop-preview___3GtjN","dropPreview":"element__drop-preview___3GtjN","label":"element__label___1JVEH","highlighted":"element__highlighted___2W4Op"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/element.css
// module id = 809
// module chunks = 0